import script from "./PortalContextSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortalContextSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./PortalContextSidebar.vue?vue&type=style&index=0&id=76406166&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76406166"]])

export default __exports__